import { TableHoverActions, useModal, withModalConditionalRender } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useGetBill } from '@features/bills/hooks/useGetBill'
import { useRegisterBillPayment } from '@features/bills/hooks/useRegisterBillPayment'
import { AccountingBasis } from '@modules-deprecated/app/organization/types/accountingBasis'

import { useSegment } from '../../../../../../../../hooks'
import { BillReconciliationModal as BillReconciliationModalComponent } from '../../../../../../../bills/elements/BillReconciliationModal'
import { TransactionsBillsActionType } from '../../../TransactionsTableStaticActions/utils/getBillsActions'

const BillReconciliationModal = withModalConditionalRender(BillReconciliationModalComponent)

interface TransactionsTableStaticActionsProps {
  originatorId: string
}

const getBillReconciliationModalId = (id: string) => `${id}-bill-reconciliation-hover-action`

export const BillsHoverActions = ({ originatorId }: TransactionsTableStaticActionsProps): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const billReconciliationModalId = getBillReconciliationModalId(originatorId)
  const { open: openBillReconciliationModal } = useModal(billReconciliationModalId)
  const { data: billData } = useGetBill(originatorId)

  const bill = billData?.bill
  const isBillPaid = bill?.isPaid
  const isCashBased = bill?.accountingBasis === AccountingBasis.Cash

  const { handleRegisterPayment: handleRegisterPaymentForBill } = useRegisterBillPayment({
    bill,
    openReconciliationModal: openBillReconciliationModal,
  })

  const handleActionClick = useCallback(() => {
    track('xxx - bookkeeping - HoverAction Clicked', {
      list: 'Bills',
      button: TransactionsBillsActionType.RegisterPayment,
    })
    handleRegisterPaymentForBill()
  }, [handleRegisterPaymentForBill, track])

  if (isCashBased || isBillPaid) {
    return <></>
  }

  return (
    <>
      <TableHoverActions>
        <TableHoverActions.Item
          icon="handCoins"
          label={t('transactions.table.static_actions.bills.registerPayment')}
          onClick={handleActionClick}
        />
      </TableHoverActions>

      {bill && <BillReconciliationModal subject={bill} id={billReconciliationModalId} />}
    </>
  )
}
